import React, { useEffect } from 'react'
import { ScrollingCarousel } from '@trendyol-js/react-carousel';
import { Link } from 'react-router-dom';
import Skeleton from 'components/shared/Skeleton';
import useGetIndexByQuery from 'sdk/hooks/search/useGetIndexByQuery';
import styles from './styles.module.scss'
import SearchBlock from './SerachBlock';

type Props = {
  search: string,
  selectedCategory?: string,
  setNotFound?: (state: boolean) => void,
}

export default function Users({ search, selectedCategory, setNotFound }: Props) {
  const {
    mutate: getIndex,
    isLoading: loading,
    data,
  } = useGetIndexByQuery()

  useEffect(() => {
    if (search !== undefined) {
      getIndex({
        query: search, index: 'salons_profiles', category: selectedCategory === 'All' ? '' : selectedCategory,
      })
    }
  }, [search, selectedCategory])

  const uniqueList = (ps: any[]) => {
    const ids = ps.map((p) => p.objectID) // @ts-ignore
    const uniqueIds = [...new Set(ids)]
    return uniqueIds.map((i) => ps.find((p) => p.objectID === i))
  }

  useEffect(() => {
    if (setNotFound) {
      if (!loading && !data?.length) {
        setNotFound(true)
      } else {
        setNotFound(false)
      }
    }
  }, [loading, data?.length])

  // @ts-ignore
  if (loading && !data?.length) {
    return (
      <SearchBlock title="Experts">
        <ScrollingCarousel className={styles.picks}>
          {Array.from(Array(9).keys()).map((item) => (
            <div key={item} className={styles.picksItem}>
              <Skeleton className={styles.picksItemAvatar} />
              <Skeleton className={styles.userName} />
            </div>
          ))}
        </ScrollingCarousel>
      </SearchBlock>
    )
  }

  if (!data?.length) {
    return <div />
  }
  return (
    <SearchBlock title="Experts" className={loading ? 'blockLoading' : ''}>
      <ScrollingCarousel className={styles.picks}>
        {data && uniqueList(data).slice(0, 4)?.map((item: any) => (
          <Link to={`/profile/${item?.username}`} key={item?.objectID} className={styles.picksItem}>
            <img className={styles.picksItemAvatar} src={item?.avatar} alt={item?.avatar} />
            <span className={styles.userName}>{item?.name}</span>
          </Link>
        ))}
      </ScrollingCarousel>
    </SearchBlock>
  )
}
